'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  fill: ', ';\n'], ['\n  width: ', ';\n  fill: ', ';\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Container = _styledComponents2.default.svg(_templateObject, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.color || props.theme.color_blue;
});
var RoundedMoney = function (_Component) {
  _inherits(RoundedMoney, _Component);
  function RoundedMoney() {
    _classCallCheck(this, RoundedMoney);
    return _possibleConstructorReturn(this, (RoundedMoney.__proto__ || Object.getPrototypeOf(RoundedMoney)).apply(this, arguments));
  }
  _createClass(RoundedMoney, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(Container, {
        viewBox: '14 1 100 120'
      }, _react2.default.createElement('path', {
        d: 'M57.7,91v-7.6c-4.3-0.1-8.8-1.4-11.5-3.3l1.8-5c2.7,1.8,6.6,3.2,10.8,3.2c5.3,0,8.9-3.1,8.9-7.3 c0-4.1-2.9-6.7-8.5-8.9c-7.7-3-12.4-6.4-12.4-13c0-6.2,4.4-11,11.3-12.1v-7.6h4.6v7.3c4.5,0.2,7.6,1.3,9.7,2.6l-1.9,4.9 c-1.6-0.9-4.6-2.5-9.4-2.5c-5.8,0-7.9,3.4-7.9,6.5c0,3.9,2.8,5.9,9.3,8.6c7.7,3.1,11.6,7,11.6,13.7c0,5.9-4.1,11.5-11.9,12.8V91 H57.7z'
      }), _react2.default.createElement('path', {
        d: 'M61,13.5c-27.3,0-49.5,22.2-49.5,49.5c0,27.3,22.2,49.5,49.5,49.5s49.5-22.2,49.5-49.5 C110.5,35.7,88.3,13.5,61,13.5z M61,108c-24.9,0-45-20.1-45-45c0-24.9,20.1-45,45-45s45,20.1,45,45C106,87.9,85.9,108,61,108z'
      }));
    }
  }]);
  return RoundedMoney;
}(_react.Component);
exports.default = RoundedMoney;